export default {
  init() {
    $('.btn').on('click', function (e) {
      if( !$(this).attr('href') ) {
        e.preventDefault();
        if( $(this).hasClass('.is--active') ) {
          $(this).removeClass('.is--active');
          $(this).parents('.membership-boxes').find('.membership-level-box').removeClass('is--toggled');
        } else {
          var boxContent = $(this).next('.member-level-content').html();
          $('.btn.is--active').removeClass('is--active');
          $('.membership-level-box.is--toggled').removeClass('is--toggled');
          $(this).addClass('is--active');
          $(this).parents('.membership-boxes').find('.membership-level-box').addClass('is--toggled');
          $(this).parents('.membership-boxes').find('.membership-level-box').html(boxContent);
        }
      }
    });
  }
}
